export const SHARE_DC = {
    DC_URLS : {},
    URLS_TO_IGNORE_UPDATING_DCCODE : ['/boards']
};